/**
 * @format
 * Action Types for Task CRUD
 */
export const GET_ALL_TASKS_LOADING = 'tasks/GET_ALL_TASKS_LOADING';
export const GET_ALL_TASKS_SUCCESS = 'tasks/GET_ALL_TASKS_SUCCESS';
export const GET_ALL_TASKS_FAILURE = 'tasks/GET_ALL_TASKS_FAILURE';

export const GET_TASK_LOADING = 'tasks/GET_TASK_LOADING';
export const GET_TASK_SUCCESS = 'tasks/GET_TASK_SUCCESS';
export const GET_TASK_FAILURE = 'tasks/GET_TASK_FAILURE';

export const CREATE_TASK_LOADING = 'tasks/CREATE_TASK_LOADING';
export const CREATE_TASK_SUCCESS = 'tasks/CREATE_TASK_SUCCESS';
export const CREATE_TASK_FAILURE = 'tasks/CREATE_TASK_FAILURE';

export const UPDATE_TASK_LOADING = 'tasks/UPDATE_TASK_LOADING';
export const UPDATE_TASK_SUCCESS = 'tasks/UPDATE_TASK_SUCCESS';
export const UPDATE_TASK_FAILURE = 'tasks/UPDATE_TASK_FAILURE';

export const DELETE_TASK_LOADING = 'tasks/DELETE_TASK_LOADING';
export const DELETE_TASK_SUCCESS = 'task/DELETE_TASK_SUCCESS';
export const DELETE_TASK_FAILURE = 'tasks/DELETE_TASK_FAILURE';
